import React from "react";
import { BadgeContainer, Text, Container } from "./styles";
import Loader from "react-loader-spinner";

const Badge = ({
  color,
  text,
  fontSize,
  disabled = false,
  loading,
  icon: Icon,
  textColor,
  bold,
  ...rest
}) => {
  return (
    <Container>
      <BadgeContainer
        color={color}
        fontSize={fontSize}
        disabled={disabled}
        textColor={textColor}
        bold={bold} 

        {...rest}
      >
        {Icon && <Icon color={textColor || ""} style={{ marginRight: 8 }} />}
        {loading ? (
          <Loader type="Oval" color="white" height="16px" />
        ) : (
          <Text style={{ color: textColor || "inherit" }}>{text}</Text>
        )}
      </BadgeContainer>
    </Container>
  );
};

export default Badge;
